import script from "./UiDropdownV2.vue?vue&type=script&lang=ts&setup=true&generic=T%20extends%20%7B%7D%2C%20P%20extends%20keyof%20T%2C%20L%20extends%20keyof%20T%2C%20M%20extends%20Modes%2C%20V%20extends%20T%2C%20O%20extends%20boolean%20%3D%20false"
export * from "./UiDropdownV2.vue?vue&type=script&lang=ts&setup=true&generic=T%20extends%20%7B%7D%2C%20P%20extends%20keyof%20T%2C%20L%20extends%20keyof%20T%2C%20M%20extends%20Modes%2C%20V%20extends%20T%2C%20O%20extends%20boolean%20%3D%20false"

const __exports__ = script;

export default __exports__